import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import L from 'leaflet';
import { Map as LeafletMap } from 'leaflet';
import _ from 'lodash';

import {
  setAnalysisPinLocation,
  deactivateAnalysisPinMode,
} from '../../store/actions';

const defaultPinIcon = new L.Icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

class AnalysisPinDropper extends React.Component {
  static contextTypes = {
    map: PropTypes.instanceOf(LeafletMap),
  };

  constructor(props) {
    super(props);
    this.map = null;
    this.analysisPinMarker = null;
  }

  componentDidMount() {
    this.map = _.get(this, 'context.map', null);
    if (!this.map) {
      return;
    }
    this.updateMapStateFromProps(null, this.props);
  }

  componentDidUpdate(prevProps) {
    if (!this.map && this.context && this.context.map) {
      this.map = this.context.map;
      this.updateMapStateFromProps(null, this.props);
      return;
    }

    if (this.map) {
      this.updateMapStateFromProps(prevProps, this.props);
    }
  }

  updateMapStateFromProps(prevProps, currentProps) {
    if (!this.map) {
      return;
    }

    const wasPinModeActive = prevProps ? prevProps.analysisPinModeActive : false;
    const isPinModeActive = currentProps.analysisPinModeActive;

    const prevPinLocation = prevProps ? prevProps.analysisPinLocation : null;
    const currentPinLocation = currentProps.analysisPinLocation;

    if (isPinModeActive !== wasPinModeActive) {
      if (isPinModeActive) {
        this.map.on('click', this.handleMapClick);
        this.map.getContainer().style.cursor = 'crosshair';
        if (this.analysisPinMarker) {
          this.analysisPinMarker.remove();
          this.analysisPinMarker = null;
        }
      } else {
        this.map.off('click', this.handleMapClick);
        this.map.getContainer().style.cursor = '';
      }
    }

    if (currentPinLocation !== prevPinLocation) {
      if (this.analysisPinMarker) {
        this.analysisPinMarker.remove();
        this.analysisPinMarker = null;
      }
      if (currentPinLocation && currentPinLocation.lat && currentPinLocation.lng) {
        this.analysisPinMarker = L.marker([currentPinLocation.lat, currentPinLocation.lng], { icon: defaultPinIcon }).addTo(this.map);
      }
    }
  }

  componentWillUnmount() {
    if (this.map) {
      this.map.off('click', this.handleMapClick);
      if (this.map.getContainer()) {
        this.map.getContainer().style.cursor = '';
      }
      if (this.analysisPinMarker) {
        this.analysisPinMarker.remove();
        this.analysisPinMarker = null;
      }
      if (this.props.analysisPinModeActive) {
        this.props.deactivateAnalysisPinMode();
      }
    }
  }

  handleMapClick = e => {
    if (!this.props.analysisPinModeActive) {
      return;
    }
    const { lat, lng } = e.latlng;
    this.props.setAnalysisPinLocation({ lat, lng });
  };

  render() {
    return null;
  }
}

AnalysisPinDropper.propTypes = {
  analysisPinModeActive: PropTypes.bool.isRequired,
  analysisPinLocation: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  setAnalysisPinLocation: PropTypes.func.isRequired,
  deactivateAnalysisPinMode: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  analysisPinModeActive: state.analysisPinModeActive,
  analysisPinLocation: state.analysisPinLocation,
});

const mapDispatchToProps = {
  setAnalysisPinLocation,
  deactivateAnalysisPinMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalysisPinDropper);



// WEBPACK FOOTER //
// ./src/components/Map/AnalysisPinDropper.js